<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 md6 offset-md3 class="pt-5 text-xs-center">
        <v-card class="red error">
          <v-card-text>
            <v-icon class="hidden-xs-only icon-absolute">warning</v-icon>
            <v-icon class="hidden-sm-and-up">warning</v-icon>
            {{ message }}
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: ['message']
  };
</script>

<style lang="less" scoped>
  @import '../../style/variables.less';

  body {
    background-color: @edval-dark;
  }

  .error {
    color: #ffffff;
    font-size: 1.2em;
    border-radius: 0;

    .icon-absolute {
      position: absolute;
      left: 25px;
    }
  }
</style>
